import React from "react";
// @material-ui/core components
import { useTheme } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import ButtonGroup from "@material-ui/core/ButtonGroup";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardHeader from "@material-ui/core/CardHeader";
import Container from "@material-ui/core/Container";
import Divider from "@material-ui/core/Divider";
import Grid from "@material-ui/core/Grid";
// @material-ui/icons components
import Archive from "@material-ui/icons/Archive";
import Grain from "@material-ui/icons/Grain";
// core components
import SimpleHeader from "components/Headers/SimpleHeader.js";
import boxShadows from "assets/theme/box-shadow.js";

const statesColors = [
  "dark",
  "primary",
  "secondary",
  "info",
  "success",
  "error",
  "warning",
];

const socialButtonColors = [
  {
    icon: "fab fa-facebook",
    text: "Facebook",
    color: "facebook",
  },
  {
    icon: "fab fa-twitter",
    text: "Twitter",
    color: "twitter",
  },
  {
    icon: "fab fa-google-plus-g",
    text: "Google +",
    color: "google",
  },
  {
    icon: "fab fa-instagram",
    text: "Instagram",
    color: "instagram",
  },
  {
    icon: "fab fa-pinterest",
    text: "Pinterest",
    color: "pinterest",
  },
  {
    icon: "fab fa-youtube",
    text: "Youtube",
    color: "youtube",
  },
  {
    icon: "fab fa-vimeo-v",
    text: "Vimeo",
    color: "vimeo",
  },
  {
    icon: "fab fa-slack",
    text: "Slack",
    color: "slack",
  },
  {
    icon: "fab fa-dribbble",
    text: "Dribbble",
    color: "dribbble",
  },
  {
    icon: "fab fa-github",
    text: "Github",
    color: "github",
  },
];

const Buttons = () => {
  const theme = useTheme();
  return (
    <>
      <SimpleHeader section="Buttons" subsection="Components" />
      {/* Page content */}
      <Container
        maxWidth={false}
        component={Box}
        sx={{
          marginTop: "-4.5rem",
          [theme.breakpoints.up("md")]: {
            paddingLeft: "30px",
            paddingRight: "30px",
          },
        }}
      >
        {/* Table */}
        <Grid
          container
          component={Box}
          sx={{ marginBottom: "39px", justifyContent: "center" }}
        >
          <Grid item xs={12} lg={8}>
            <Card sx={{ boxShadow: boxShadows.boxShadow + "!important" }}>
              <CardHeader
                sx={{ backgroundColor: "initial" }}
                title="Styles"
                titleTypographyProps={{
                  component: Box,
                  sx: { marginBottom: "0!important" },
                  variant: "h3",
                }}
              ></CardHeader>
              <CardContent>
                <Box
                  sx={{
                    display: "inline-block",
                    marginRight: "1rem",
                    marginBottom: "1rem",
                  }}
                >
                  <Button color="primary" variant="contained">
                    Button
                  </Button>
                </Box>
                <Box
                  sx={{
                    display: "inline-block",
                    marginRight: "1rem",
                    marginBottom: "1rem",
                  }}
                >
                  <Button color="primary" variant="contained">
                    <Box
                      component={Archive}
                      sx={{
                        marginRight: ".75em",
                        top: "-2px",
                        position: "relative",
                      }}
                    />
                    With Icons
                  </Button>
                </Box>
                <Box
                  sx={{
                    display: "inline-block",
                    marginRight: "1rem",
                    marginBottom: "1rem",
                  }}
                >
                  <Button color="primary" variant="contained">
                    <Box
                      component={Grain}
                      sx={{ top: "-2px", position: "relative" }}
                    />
                  </Button>
                </Box>
              </CardContent>
            </Card>
            <Card sx={{ boxShadow: boxShadows.boxShadow + "!important" }}>
              <CardHeader
                sx={{ backgroundColor: "initial" }}
                title="Colors"
                titleTypographyProps={{
                  component: Box,
                  sx: { marginBottom: "0!important" },
                  variant: "h3",
                }}
              ></CardHeader>
              <CardContent>
                {statesColors.map((prop, key) => (
                  <React.Fragment key={key}>
                    <Box
                      sx={{
                        display: "inline-block",
                        marginRight: "1rem",
                        marginBottom: "1rem",
                      }}
                    >
                      <Button variant="contained" color={prop}>
                        {prop.charAt(0).toUpperCase() + prop.slice(1)}
                      </Button>
                    </Box>
                  </React.Fragment>
                ))}
              </CardContent>
            </Card>
            <Card sx={{ boxShadow: boxShadows.boxShadow + "!important" }}>
              <CardHeader
                sx={{ backgroundColor: "initial" }}
                title="Outline"
                titleTypographyProps={{
                  component: Box,
                  sx: { marginBottom: "0!important" },
                  variant: "h3",
                }}
              ></CardHeader>
              <CardContent>
                {statesColors.map((prop, key) => (
                  <React.Fragment key={key}>
                    <Box
                      sx={{
                        display: "inline-block",
                        marginRight: "1rem",
                        marginBottom: "1rem",
                      }}
                    >
                      <Button variant="outlined" color={prop}>
                        {prop.charAt(0).toUpperCase() + prop.slice(1)}
                      </Button>
                    </Box>
                  </React.Fragment>
                ))}
              </CardContent>
            </Card>
            <Card sx={{ boxShadow: boxShadows.boxShadow + "!important" }}>
              <CardHeader
                sx={{ backgroundColor: "initial" }}
                title="Sizes"
                titleTypographyProps={{
                  component: Box,
                  sx: { marginBottom: "0!important" },
                  variant: "h3",
                }}
              ></CardHeader>
              <CardContent>
                <Box
                  sx={{
                    display: "inline-block",
                    marginRight: "1rem",
                    marginBottom: "1rem",
                  }}
                >
                  <Button size="large" color="primary" variant="contained">
                    Large button
                  </Button>
                </Box>
                <Box
                  sx={{
                    display: "inline-block",
                    marginRight: "1rem",
                    marginBottom: "1rem",
                  }}
                >
                  <Button size="large" color="secondary" variant="contained">
                    Large button
                  </Button>
                </Box>
                <Box
                  component={Divider}
                  sx={{
                    marginTop: "2rem!important",
                    marginBottom: "2rem!important",
                  }}
                />
                <Box
                  sx={{
                    display: "inline-block",
                    marginRight: "1rem",
                    marginBottom: "1rem",
                  }}
                >
                  <Button size="small" color="primary" variant="contained">
                    Small button
                  </Button>
                </Box>
                <Box
                  sx={{
                    display: "inline-block",
                    marginRight: "1rem",
                    marginBottom: "1rem",
                  }}
                >
                  <Button size="small" color="secondary" variant="contained">
                    Small button
                  </Button>
                </Box>
                <Box
                  component={Divider}
                  sx={{
                    marginTop: "2rem!important",
                    marginBottom: "2rem!important",
                  }}
                />
                <Box sx={{ display: "block", marginBottom: "1rem" }}>
                  <Button color="primary" variant="contained" fullWidth>
                    Block level
                  </Button>
                </Box>
                <Button color="secondary" variant="contained" fullWidth>
                  Block level
                </Button>
              </CardContent>
            </Card>
            <Card sx={{ boxShadow: boxShadows.boxShadow + "!important" }}>
              <CardHeader
                sx={{ backgroundColor: "initial" }}
                title="Group"
                titleTypographyProps={{
                  component: Box,
                  sx: { marginBottom: "0!important" },
                  variant: "h3",
                }}
              ></CardHeader>
              <CardContent>
                <ButtonGroup
                  variant="contained"
                  color="secondary"
                  aria-label="contained-secondary-button-group"
                >
                  <Button>Left</Button>
                  <Button>Middle</Button>
                  <Button>Right</Button>
                </ButtonGroup>
                <Box
                  component={Divider}
                  sx={{
                    marginTop: "2rem!important",
                    marginBottom: "2rem!important",
                  }}
                />
                <Box
                  sx={{
                    display: "inline-block",
                    marginRight: ".25rem",
                    marginBottom: "1rem",
                  }}
                >
                  <ButtonGroup
                    variant="contained"
                    aria-label="contained-info-button-group"
                    color="info"
                  >
                    <Button>1</Button>
                    <Button>2</Button>
                    <Button>3</Button>
                    <Button>4</Button>
                  </ButtonGroup>
                </Box>
                <ButtonGroup
                  variant="contained"
                  aria-label="contained-default-button-group"
                  color="dark"
                >
                  <Button>5</Button>
                  <Button>6</Button>
                  <Button>7</Button>
                </ButtonGroup>
              </CardContent>
            </Card>
            <Card sx={{ boxShadow: boxShadows.boxShadow + "!important" }}>
              <CardHeader
                sx={{ backgroundColor: "initial" }}
                title="Social"
                titleTypographyProps={{
                  component: Box,
                  sx: { marginBottom: "0!important" },
                  variant: "h3",
                }}
              ></CardHeader>
              <CardContent>
                {socialButtonColors.map((prop, key) => (
                  <Box
                    key={key}
                    sx={{
                      display: "inline-block",
                      marginRight: "1rem",
                      marginBottom: "1rem",
                    }}
                  >
                    <Button variant="contained" color={prop.color}>
                      <Box
                        component="i"
                        sx={{ marginRight: ".5rem" }}
                        className={prop.icon}
                      />
                      {prop.text}
                    </Button>
                  </Box>
                ))}
                <Box
                  component={Divider}
                  sx={{
                    marginTop: "2rem!important",
                    marginBottom: "2rem!important",
                  }}
                />
                {socialButtonColors.map((prop, key) => (
                  <Box
                    key={key}
                    sx={{
                      display: "inline-block",
                      marginRight: "1rem",
                      marginBottom: "1rem",
                    }}
                  >
                    <Button variant="contained" color={prop.color}>
                      <Box component="i" className={prop.icon} />
                    </Button>
                  </Box>
                ))}
                <Box
                  component={Divider}
                  sx={{
                    marginTop: "2rem!important",
                    marginBottom: "2rem!important",
                  }}
                />
                {socialButtonColors.map((prop, key) => (
                  <Box
                    key={key}
                    sx={{
                      display: "inline-block",
                      marginRight: "1rem",
                      marginBottom: "1rem",
                    }}
                  >
                    <Button
                      variant="contained"
                      color={prop.color}
                      sx={{
                        borderRadius: "50%!important",
                        width: "2.375rem",
                        height: "2.375rem",
                        padding: "0",
                        minWidth: "unset",
                      }}
                    >
                      <Box
                        sx={{ fontSize: "14px" }}
                        component="i"
                        className={prop.icon}
                      />
                    </Button>
                  </Box>
                ))}
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Container>
    </>
  );
};

export default Buttons;
